import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isAzureAdConfigured, loginRequest } from '../auth/msalConfig';
import { LoadingSpinner } from '../components/common/LoadingSpinner';

// With ProtectedRoute auto-redirecting, users typically never see this page.
// It exists as a safety net: if a user lands here directly, kick off sign-in
// (or send them to the dashboard if they're already signed in).
export const LoginPage: React.FC = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAzureAdConfigured || isAuthenticated || inProgress !== 'none') {
      return;
    }
    void instance.loginRedirect(loginRequest);
  }, [instance, isAuthenticated, inProgress]);

  if (!isAzureAdConfigured || isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <LoadingSpinner message="Signing in..." />;
};
